import SearchInput from "common/components/Autocomplete/SearchInput";
import HeaderNav from "components/HeaderNav/headerNav";
import { useReports } from "hooks/useReports";
import React, { useEffect, useState } from "react";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import { UserRole } from "components/Reports/reportAssets/assets";
import SearchOrDeleteElement from "./SearchOrDeleteElement";

const HeaderForReportsTabs = () => {
  const locationString = useLocationForReportType();
  const isMessagesScreen = locationString === "followup-messages";
  const isControlCenterPath = locationString === "control-center";
  const selectedRole = useGetUserData(LocalStorageKey.SelectedRole)?.value;
  const { searchKeyword, setSearchKeyword } = useReports();
  const [handleSearch, setHandleSearch] = useState<boolean>(false);

  const [prevSelectedRole, setPrevSelectedRole] = useState(selectedRole);

  useEffect(() => {
    // Reset searchKeyword when selectedRole changes
    if (prevSelectedRole !== selectedRole) {
      setSearchKeyword("");
      setPrevSelectedRole(selectedRole);
    }
  }, [selectedRole, prevSelectedRole, setSearchKeyword]);

  return (
    <>
      {selectedRole !== UserRole.CONTROLCENTER && <HeaderNav />}
      <div className={isControlCenterPath || isMessagesScreen ? "hidden" : ""}>
        <div className="searchBox">
          <SearchInput
            searchKeyword={searchKeyword}
            setSearchKeyword={setSearchKeyword}
            setHandleSearch={setHandleSearch}
            handleSearch={handleSearch}
          />
          <SearchOrDeleteElement setHandleSearch={setHandleSearch} />
        </div>
      </div>
    </>
  );
};
export default HeaderForReportsTabs;
